// Individual Metrics
const TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA = {
  TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_LOAD: "TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_LOAD",
  TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_SUCCESS: "TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_SUCCESS",
  TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_FAIL: "TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_FAIL",
};
const TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_API = "tickets/metrics/performance/individual";

// Team Metrics
const TICKET_DASHBOARD_METRICS_TEAM_GET_DATA = {
  TICKET_DASHBOARD_METRICS_TEAM_GET_LOAD: "TICKET_DASHBOARD_METRICS_TEAM_GET_LOAD",
  TICKET_DASHBOARD_METRICS_TEAM_GET_SUCCESS: "TICKET_DASHBOARD_METRICS_TEAM_GET_SUCCESS",
  TICKET_DASHBOARD_METRICS_TEAM_GET_FAIL: "TICKET_DASHBOARD_METRICS_TEAM_GET_FAIL",
};
const TICKET_DASHBOARD_METRICS_TEAM_GET_API = "tickets/metrics/performance/team";

// Organization Metrics
const TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA = {
  TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_LOAD: "TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_LOAD",
  TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_SUCCESS: "TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_SUCCESS",
  TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_FAIL: "TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_FAIL",
};
const TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_API = "tickets/metrics/performance/organization";

export {
  TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA,
  TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_API,
  TICKET_DASHBOARD_METRICS_TEAM_GET_DATA,
  TICKET_DASHBOARD_METRICS_TEAM_GET_API,
  TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA,
  TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_API,
};